import { render, staticRenderFns } from "./CustomerAgents.vue?vue&type=template&id=4ba0bf94"
import script from "./CustomerAgents.vue?vue&type=script&lang=js"
export * from "./CustomerAgents.vue?vue&type=script&lang=js"
import style0 from "./CustomerAgents.vue?vue&type=style&index=0&id=4ba0bf94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports